export const tags = (
  data,
) => (
  Object.keys(data)
);
